import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';

// devices routing
const User = Loadable(lazy(() => import('./users/User')));
const PermissionLevels = Loadable(lazy(() => import('./permission-levels/PermissionLevels')));

// ==============================|| MAIN ROUTING ||============================== //

const UserManagementRoutes = {
    path: 'userManagement',
    children: [
        {
            path: 'users',
            element: <User />
        },
        {
            path: 'permissionLevels',
            element: <PermissionLevels />
        }
    ]
};

export default UserManagementRoutes;
